import { yupResolver } from '@hookform/resolvers/yup';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import displayCustomTextareas from '@Shared/utils/displayCustomTextareas';
import React from 'react';
import { useForm } from 'react-hook-form';
import { TCurrencyDefinitionDataTableData } from '@Modules/admin/basicSettings/containers/formHandlers/center/currency/currencyDefinition/CurrencyDefinitionDataTableMeta';

import { ICurrencyDefinitionDataTableRowFormMeta } from '@Modules/admin/basicSettings/containers/formHandlers/center/currency/currencyDefinition/CurrencyDefinitionDataTableRowMeta';
type Props = {
    meta: ICurrencyDefinitionDataTableRowFormMeta,
    data: TCurrencyDefinitionDataTableData
} & TFormUIProps;

export default React.forwardRef(function CurrencyDefinitionTableFormUI ({ onSubmit, isLoading, isSubmitting, meta, data }: Props, ref: any) {

  const submitBtnRef = React.useRef<HTMLButtonElement>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ 
    defaultValues: data,
    resolver: yupResolver(meta.schema) 
  });

  React.useImperativeHandle(ref, () => ({
    submitBtnRef
  }));

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)} ref={ref}>
        
      <CC.SimpleGrid columns={{base: 1, md: 2}} spacing={10} my={10}>
        {displayCustomInputs<ICurrencyDefinitionDataTableRowFormMeta>(meta, register, errors, isLoading, [meta.associationTable.name, meta.nameTable.name])}
      </CC.SimpleGrid>

      <CC.SimpleGrid columns={{base: 1, md: 1}} spacing={10} my={10}>
        {displayCustomInputs<ICurrencyDefinitionDataTableRowFormMeta>(meta, register, errors, isLoading, [ meta.decimalTable.name])}
      </CC.SimpleGrid>

      
      <button type={'submit'} ref={submitBtnRef} style={{display: "none"}}>
        Enregistrer
      </button>
    </CC.Box>
  );
});

// export default CurrencyDefinitionFormUI;
